export default "__VITE_ASSET__CewbSXoa__"